
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/center/local-center",
      function () {
        return require("private-next-pages/[region]/center/local-center/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/center/local-center"])
      });
    }
  